module.exports = __webpack_public_path__ + "img/LL.3010981e.png";